/**
 * Recents' tabs. Its own module because the router validates `?tab=` against
 * it, and the router is in the entry chunk — the library's data layer is not.
 */
export const RECENT_TABS = ['edited', 'shared', 'revoice'] as const
export type RecentTab = (typeof RECENT_TABS)[number]
